import React, { ButtonHTMLAttributes, ReactNode } from "react";
import classNames from "classnames";
import styles from "./Button.module.css";

type ButtonVariant = "primary" | "secondary" | "success" | "danger" | "link";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  isLoading?: boolean;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  disabled?: boolean;
  children: ReactNode;
}

export const Button: React.FC<ButtonProps> = ({
  variant = "primary",
  isLoading = false,
  startIcon,
  endIcon,
  disabled,
  children,
  className,
  ...props
}) => {
  const buttonClasses = classNames(
    styles.btn,
    styles[`btn${variant.charAt(0).toUpperCase() + variant.slice(1)}`],
    { [styles.btnLoading]: isLoading },
    className
  );

  return (
    <button
      className={buttonClasses}
      disabled={isLoading || disabled}
      aria-busy={isLoading}
      {...props}
    >
      {isLoading ? (
        <span className={styles.btnSpinner} aria-hidden="true"></span>
      ) : (
        <>
          {startIcon && (
            <span className={`${styles.btnIcon} ${styles.btnIconStart}`}>
              {startIcon}
            </span>
          )}
          <span className={styles.btnText}>{children}</span>
          {endIcon && (
            <span className={`${styles.btnIcon} ${styles.btnIconEnd}`}>
              {endIcon}
            </span>
          )}
        </>
      )}
    </button>
  );
};
